// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wb4u","buttons":"styles_buttons__3ylcl"};